/**
 * Содержатся ли все элементы из массива 2 в массиве 1.
 * @param array1 - Массив 1
 * @param array2 - Массив 2
 */
export const multipleExist = <T>(array1: Array<T>, array2: Array<T>) => {
    return array2.every(value => array1.includes(value))
}
